import { IInstallmentDetail } from "@/types/IInstallment";

/**
 * Persists the minimal payment selection across an external redirect (e.g. the
 * Xendit GCash / Maya e-wallet flow) so the user can resume on the provider
 * selection screen instead of re-picking the amount.
 *
 * A full-page redirect back from the payment provider reinitializes the
 * in-memory Vuex store, so the selected amount would otherwise be lost. Only the
 * lightweight, PII-free selection is stored here; the finance product (which
 * carries customer PII) is re-fetched from the backend on reload rather than
 * persisted (PYMT-2398).
 */
const RESUME_PROVIDERS_KEY = "resumeProvidersSelection";

export interface ResumeProvidersSelection {
  deviceTag: string;
  selectedInstallment: IInstallmentDetail;
  superPacmanSelectedAmount: number;
  paymentOption?: string;
}

export function saveResumeProvidersSelection(selection: ResumeProvidersSelection): void {
  try {
    localStorage.setItem(RESUME_PROVIDERS_KEY, JSON.stringify(selection));
  } catch {
    // Best-effort: a storage failure just means the user resumes at amount selection.
  }
}

export function getResumeProvidersSelection(): ResumeProvidersSelection | null {
  try {
    const raw = localStorage.getItem(RESUME_PROVIDERS_KEY);
    return raw ? (JSON.parse(raw) as ResumeProvidersSelection) : null;
  } catch {
    return null;
  }
}

export function clearResumeProvidersSelection(): void {
  localStorage.removeItem(RESUME_PROVIDERS_KEY);
}
